<template>
  <div class="facility">
    <div
      style="
        height: 40px;
        display: flex;
        font-size: 18px;
        font-weight: bold;
        align-items: center;
      "
    >
      <div style="margin-right: 10px">
        <el-button type="primary" @click="$router.go(-1)"
          ><i class="el-icon-back" style="margin-right: 10px"></i>
          后退前页</el-button
        >
      </div>
      <div style="color: #000">
        <span
          style="cursor: pointer"
          @click="$router.push('/ProjectInfo/ProjectAll?id=' + $route.query.id)"
          >{{ backName || '工作台' }}</span
        >
        <i class="el-icon-arrow-right"></i>
      </div>
      <div style="color: #606266" class="ellipsis">资料模板</div>
    </div>
    <div style="display: flex; align-items: center">
      <el-card
        style="width: 300px; height: calc(100vh - 130px)"
        :body-style="{
          height: '100%',
          overflowY: 'auto',
          padding: 0,
        }"
        v-loading="leftLoading"
      >
        <div style="position: relative; padding: 20px">
          <div
            style="
              position: sticky;
              top: 0px;
              left: 0px;
              z-index: 999;
              height: 40px;
              display: flex;
              flex-wrap: wrap;
              align-items: center;
              background-color: #fff;
            "
          >
            <!-- <el-button
              style="width: 100%; margin-bottom: 10px; margin-top: 10px"
              type="primary"
              @click="AddFacility"
              >配置当前项目设备分类</el-button
            > -->

            <el-input
              placeholder="输入关键字进行过滤"
              v-model="filterText"
              @input="leftDataSearch"
              style="width: 100%"
            >
            </el-input>
          </div>
          <div style="margin-top: 10px">
            <el-tree
              ref="tree"
              :data="TreeData"
              node-key="Id"
              :expand-on-click-node="false"
              :props="defaultProps"
              @node-click="handleNodeClick"
              :filter-node-method="filterNode"
              highlight-current
              :indent="10"
            >
              <span class="custom-tree-node" slot-scope="{ node, data }">
                <span style="font-size: 14px"
                  >{{ node.label }}
                  <!-- <el-tag
                    v-if="data.flag"
                    style="font-size: 10px; float: right"
                    type="success"
                    >已有模板</el-tag
                  > -->
                  <el-tag
                    v-if="!data.flag && data.Level > 2"
                    style="font-size: 10px; float: right"
                    type="warning"
                    >无模板</el-tag
                  >
                </span>
              </span>
            </el-tree>
          </div>
        </div>
      </el-card>
      <el-card
        style="
          width: calc(100% - 320px);
          height: calc(100vh - 130px);
          margin-left: 20px;
          font-size: 14px;
          position: relative;
        "
        :body-style="{
          height: '100%',
          overflowY: 'auto',
        }"
        v-loading="loading"
      >
        <div
          style="position: absolute; right: 20px; top: 10px; z-index: 999"
          v-if="DataShow"
        >
          <el-button
            type="primary"
            @click="handleAllot"
            icon="el-icon-guide"
            v-if="ProjectInfo.ProjectStatus == 2"
            >模板下发</el-button
          >
          <el-button
            type="primary"
            @click="handleEdit"
            icon="el-icon-edit-outline"
            >模板配置</el-button
          >
          <el-button type="primary" @click="handleAdd" icon="el-icon-tickets"
            >已分配供应商</el-button
          >
        </div>
        <el-tabs
          class="wellhole"
          v-model="activeName"
          type="card"
          @tab-click="handleClick"
          style=""
          v-if="DataShow"
        >
          <el-tab-pane
            v-for="itemI in DeviceTabList"
            :key="itemI.DeviceTab"
            :label="itemI.DeviceTabName"
            :name="itemI.DeviceTab"
          >
            <!-- //字段信息 -->
            <div
              v-if="itemI.DeviceTab !== 'DocumentInformation'"
              style="display: flex; width: 100%; flex-wrap: wrap"
            >
              <div
                v-for="item in infoObj[itemI.DeviceTab]"
                :key="item.FiledKey"
                :style="`width:${
                  100 / item.width
                }%;margin-bottom:10px;padding-left:10px;padding-right:10px;box-sizing: border-box;padding-top:2px;padding-bottom:2px;`"
              >
                <div style="display: flex; width: 100%">
                  <span
                    style="
                      display: inline-block;
                      width: 100px;
                      display: flex;
                      align-items: center;
                    "
                  >
                    <span style="color: red" v-if="item.disabled">*</span
                    >{{ item.FieldName }}</span
                  >
                  <el-input
                    v-model="item.value"
                    placeholder="请输入内容"
                    v-if="item.ComponentType === 'InputText'"
                    style="width: calc(100% - 100px)"
                    type="textarea"
                    :rows="item.rows || 1"
                    resize="none"
                    disabled
                    size="mini"
                  ></el-input>
                  <el-input
                    v-model="item.value"
                    placeholder="请输入内容"
                    v-if="item.ComponentType === 'InputNumber'"
                    style="width: calc(100% - 100px)"
                    type="number"
                    resize="none"
                    disabled
                    size="mini"
                  ></el-input>
                  <el-date-picker
                    v-model="item.value"
                    type="date"
                    placeholder="选择日期"
                    v-if="item.ComponentType === 'DatePicker'"
                    size="mini"
                    disabled
                    value-format="yyyy-MM-dd"
                    style="width: calc(100% - 100px)"
                  >
                  </el-date-picker>
                  <el-radio-group
                    v-model="item.value"
                    v-if="item.ComponentType === 'Radio'"
                    disabled
                    style="
                      width: calc(100% - 100px);
                      height: 28px;
                      display: flex;
                      align-items: center;
                      line-height: 28px;
                    "
                    size="mini"
                  >
                    <el-radio
                      v-for="val in item.Source ? JSON.parse(item.Source) : []"
                      :label="val.value"
                      :key="val.value"
                    >
                      {{ val.value }}</el-radio
                    >
                  </el-radio-group>
                  <el-select
                    v-model="item.value"
                    v-if="item.ComponentType === 'Select'"
                    placeholder="请选择"
                    style="width: calc(100% - 100px)"
                    size="mini"
                    clearable
                    disabled
                  >
                    <el-option
                      v-for="val in item.Source ? JSON.parse(item.Source) : []"
                      :key="val.value"
                      :label="val.value"
                      :value="val.value"
                    >
                    </el-option>
                  </el-select>
                </div>
              </div>
            </div>
            <!-- 文档信息 -->
            <div
              v-if="itemI.DeviceTab === 'DocumentInformation'"
              style="display: flex; width: 100%; flex-wrap: wrap"
            >
              <div
                v-for="item in infoObj[itemI.DeviceTab] || []"
                :key="item.FiledKey"
                :style="`width:${
                  100 / item.width
                }%;margin-bottom:10px;padding-left:10px;padding-right:10px;box-sizing: border-box;`"
                @click="addItem(item)"
              >
                <!-- <div>{{ item.FiledName }}</div> -->
                <el-table
                  style="width: 100%"
                  :data="
                    item.device_TypeTwoDocuments.filter((vall) =>
                      item.cList.includes(vall.Type)
                    )
                  "
                  :class="`${
                    item.FiledKey === ItemInfo.FiledKey ? 'active' : ''
                  }`"
                  header-row-class-name="header-class"
                >
                  <el-table-column
                    prop="TypeName"
                    :label="item.FieldName"
                    :resizable="false"
                  >
                    <template slot-scope="scope">
                      <span>
                        <span style="color: red" v-if="scope.row.disabled"
                          >*</span
                        >
                        {{ `${scope.row.TypeName}` }}</span
                      >
                      <el-popover
                        placement="bottom-start"
                        v-if="scope.row.Remark"
                        :open-delay="100"
                        width="200"
                        trigger="hover"
                        :content="scope.row.Remark"
                        popper-class="table-popper"
                      >
                        <i class="el-icon-question" slot="reference"></i>
                      </el-popover>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="Name"
                    label="文件名称"
                    :resizable="false"
                  ></el-table-column>
                  <el-table-column
                    prop="size"
                    label="文件大小"
                    :resizable="false"
                  ></el-table-column>
                  <el-table-column
                    prop="date"
                    label="上传日期"
                    :resizable="false"
                  ></el-table-column>
                </el-table>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
        <el-empty v-if="!DataShow">
          <span slot="description">
            <span v-if="!TreeId" style="font-size: 18px; font-weight: bold"
              >请选择下级设备分类</span
            >
            <span v-if="TreeId">暂无数据</span>
          </span>
          <el-button type="primary" v-if="TreeId" @click="handleEdit"
            >添加设计模板</el-button
          >
        </el-empty>
        <div style="height: 60px"></div>
      </el-card>
    </div>
    <el-dialog
      title="添加设备分类"
      :visible.sync="dialogVisible"
      width="60%"
      top="5vh"
      @close="close"
    >
      <div
        style="width: 100%; height: 70vh; overflow-y: auto"
        v-loading="dialogLoading"
        class="dialogTree"
      >
        <el-tree
          :data="dialogTreeData"
          show-checkbox
          node-key="id"
          :props="defaultProps"
          ref="dialogTree"
          @check-change="handleCheckChange"
        >
          <span class="custom-tree-node" slot-scope="{ node, data }">
            <span
              v-if="data.children && data.children.length > 0"
              style="font-weight: 1000; font-size: 16px"
            >
              <i class="el-icon-s-grid" style="font-size: 18px"></i>&nbsp;{{
                node.label
              }}</span
            >
            <span v-if="!data.children"
              ><i class="el-icon-receiving"></i> {{ node.label }}</span
            >
            <!-- <span> {{ data }}</span> -->
          </span>
        </el-tree>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogTreeSave">确 定</el-button>
      </span>
    </el-dialog>
    <DesignPattern
      ref="DesignPattern"
      @save="saveDesignPattern"
    ></DesignPattern>
    <FacilityTeam ref="FacilityTeam"> </FacilityTeam>
  </div>
</template>
<script>
import DesignPattern from '@/views/DesignPattern/DesignPattern.vue'

import FacilityTeam from './FacilityTeam.vue'

export default {
  data() {
    return {
      ProjectInfo: {},
      ProjectLoading: false,
      backName: '',
      TreeData: [],
      defaultProps: {
        children: 'children',
        label: 'title',
      },
      filterText: '',
      leftDataCopy: [],
      leftLoading: true,
      TreeId: '',
      DeviceTabList: [],
      activeName: '',
      infoObj: {},
      ProjectId: '',
      loading: false,
      ItemInfo: {},
      DataShow: false,
      dialogVisible: false,
      dialogTreeData: [],
      EquipmentClassificationIds: [],
      dialogLoading: false,
      ProjectEquipmentClassificationIds: [],
    }
  },
  props: {},
  components: { DesignPattern, FacilityTeam },
  methods: {
    async getProjectInfo(id) {
      this.ProjectLoading = true
      await this.$http
        .post('/Base_ProjectWork/Base_Project/GetTheData', { id })
        .then((res) => {
          this.ProjectLoading = false
          if (res.Success) {
            this.ProjectInfo = res.Data
          } else {
            this.$notify.error(res.Msg)
          }
        })
    },
    handleAllot() {
      this.$confirm('确认下发该模板?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        this.loading = true
        let res = await this.$http.post(
          `/Device_TypeWork/Device_TypeTemplate/ProjectDictionaryMainDevolve?DeviceType=${this.TreeId}&ProjectId=${this.ProjectId}`,
          {}
        )
        this.loading = false
        if (res.Success) {
          this.$notify.success('下发成功')
        } else {
          this.$notify.error(res.Msg)
        }
      })
    },
    handleAdd() {
      this.$refs.FacilityTeam.open(
        this.TreeId,
        this.TreeName || '设备分类',
        this.ProjectId
      )
    },
    saveDesignPattern() {
      if (this.TreeId) {
        this.getTreeData()
        this.getTemplateInfo(this.TreeId)
        this.getDeviceTabList(this.TreeId)
      }
    },
    dialogTreeSave() {
      this.dialogLoading = true
      this.$http
        .post('/Base_ProjectWork/Base_Project/SaveProjectDeviceTypeData', {
          ProjectId: this.ProjectId,
          EquipmentClassificationIds: this.EquipmentClassificationIds,
        })
        .then((res) => {
          this.dialogLoading = false
          if (res.Success) {
            this.$notify.success('保存成功')
            this.dialogVisible = false
            this.getTreeData()
          } else {
            this.$notify.error(res.Msg)
          }
        })
    },
    getDialogTreeData(Data) {
      this.dialogLoading = true
      this.$http
        .post(
          '/Base_ProjectManage/Project_DictionaryMain/GetDictionaryTreeByDicKey?DicKey=EquipmentClassification'
        )
        .then((resJson) => {
          if (resJson.Success) {
            this.dialogLoading = false
            this.dialogTreeData = resJson.Data[0].children
            this.EquipmentClassificationIds = JSON.parse(JSON.stringify(Data))
            this.$nextTick(() => {
              console.log(Data, '33333333')
              if (Data.length > 0) {
                if (
                  this.$refs.dialogTree &&
                  this.$refs.dialogTree.setCheckedKeys
                ) {
                  this.$refs.dialogTree.setCheckedKeys(Data)
                }
              } else {
                if (
                  this.$refs.dialogTree &&
                  this.$refs.dialogTree.setCheckedKeys &&
                  this.$refs.dialogTree.getCheckedNodes
                ) {
                  this.$refs.dialogTree.setCheckedKeys(
                    this.$refs.dialogTree.getCheckedNodes(),
                    false
                  )
                }
              }
            })
          }
        })
    },
    handleCheckChange() {
      // console.log(data, checked, indeterminate);

      // console.log(this.$refs.dialogTree.getCheckedKeys());
      this.EquipmentClassificationIds =
        this.$refs.dialogTree && this.$refs.dialogTree.getCheckedKeys
          ? this.$refs.dialogTree.getCheckedKeys()
          : []
      // console.log(this.EquipmentClassificationIds);
    },
    close() {
      this.dialogVisible = false
    },
    AddFacility() {
      this.dialogVisible = true
      let Data = this.ProjectEquipmentClassificationIds
      this.EquipmentClassificationIds = []
      this.dialogTreeData = []
      this.getDialogTreeData(Data)
    },
    handleEdit() {
      this.$refs.DesignPattern.openDesignPattern(
        this.ProjectId,
        this.TreeId,
        this.TreeName
      )
      // this.$router.push({
      //   path: "/DesignPattern",
      //   query: {
      //     Id: this.ProjectId,
      //     TreeId: this.TreeId,
      //     TreeName: this.TreeName,
      //   },
      // });
    },
    handleClick(val) {
      console.log(val.name)
      this.activeName = val.name
      // if (this.ClassifyValue) {
      //   this.ItemInfo = {};
      //   // this.getTemplateList(this.ClassifyValue[1]);
      // }
    },
    //获取选项卡信息
    async getDeviceTabList(DeviceType) {
      this.loading = true
      await this.$http
        .post(
          `/Device_TypeWork/Device_TypeCorresponding/GetDeviceTabDataList?DeviceType=${DeviceType}`
        )
        .then(async (res) => {
          this.loading = false
          if (res.Success) {
            this.DeviceTabList = res.Data
            //如未添加选项卡则清空模板
            if (res.Data.length > 0) {
              this.activeName = this.DeviceTabList[0].DeviceTab
            } else {
              this.activeName = ''
              // this.infoObj = {};
              // this.leftData = [];
              // this.leftDataCopy = [];
              // this.ItemInfo = {};
            }
            //初始化建立信息对象
          }
        })
    },
    getTemplateInfo(DeviceType) {
      this.loading = true
      this.$http
        .post(
          `/Device_TypeWork/Device_TypeTemplate/GetDeviceTypeTemplateData?ProjectId=${this.ProjectId}&DeviceType=${DeviceType}`
        )
        .then((res) => {
          this.loading = false
          if (res.Success) {
            this.DataShow = true
            this.infoObj = res.Data.device_TypeTemplate.Content
              ? JSON.parse(res.Data.device_TypeTemplate.Content)
              : {}
            console.log(this.infoObj, 'this.infoObj')
          } else {
            this.DataShow = false
            // this.$notify.error(res.Msg);
          }
        })
        .catch((err) => {
          this.loading = false
          this.DataShow = false
          console.log(err)
        })
    },
    async handleNodeClick(data) {
      console.log(data)

      if (data.Level <= 2) {
        this.$notify.warning('请选择下级分类')
        this.DataShow = false
        this.TreeId = ''
        this.TreeName = ''
      } else {
        this.TreeId = data.Id
        this.TreeName = data.title
        this.DataShow = false
        this.getTemplateInfo(this.TreeId)
        await this.getDeviceTabList(this.TreeId)
      }
    },
    leftDataSearch() {
      this.$refs.tree.filter(this.filterText)
    },
    filterNode(value, data) {
      if (!value) return true
      return data.title.indexOf(value) !== -1
    },
    getTreeData() {
      this.EquipmentClassificationIds = []
      this.leftLoading = true
      this.$http
        .post(
          '/Base_ProjectWork/Base_Project/GetProjectDevice?ProjectId=' +
            this.ProjectId
        )
        .then((resJson) => {
          this.leftLoading = false
          if (resJson.Success) {
            this.ProjectEquipmentClassificationIds = [
              ...resJson.Data.EquipmentClassificationIds,
            ]
            let Data = resJson.Data.Data
            this.TreeData = Data[0].children
            window.sessionStorage.setItem(
              'treeData',
              JSON.stringify(resJson.Data)
            )
            if (this.TreeId) {
              this.$nextTick(() => {
                this.$refs.tree.setCurrentKey(this.TreeId)
              })
            }
          }
        })
    },
  },
  mounted() {},
  created() {
    this.ProjectId = this.$route.query.id
    this.backName = window.localStorage.getItem('ProjectName') || ''
    this.getTreeData()
    this.getProjectInfo(this.ProjectId)
  },
  activated() {
    // console.log(111111111);
    // if (this.TreeId) {
    //   this.getTemplateInfo(this.TreeId);
    //   this.getDeviceTabList(this.TreeId);
    // }
  },
  computed: {},
  watch: {},
}
</script>
<style lang="scss" scoped>
.facility {
  width: 100%;
  height: calc(100vh - 65px);
  padding: 10px;
  padding-top: 0;
  box-sizing: border-box;
  background: #fff;
  overflow: hidden;
}

::v-deep
  .el-tree--highlight-current
  .el-tree-node.is-current
  > .el-tree-node__content {
  background-color: #409eff;
  color: #fff;
  font-weight: bold;
}

::v-deep .el-tree-node {
  white-space: normal;
  .el-tree-node__content {
    // height: 100%;
    // height: 30px;
  }
}
::v-deep .el-descriptions-item__cell {
  width: 25%;
  text-align: right;
}
::v-deep .descriptionsLabel {
  font-weight: 800 !important;
  // color: #000;
  font-size: 14px;
}
::v-deep .wellhole .el-table th .cell {
  font-weight: bold;
  font-size: 14px;
  color: #000000;
}
// ::v-deep .header-class {
//   font-weight: bold;
//   .cell {
//     font-size: 14px;
//     color: #000;
//   }
// }
.custom-tree-node {
  display: inline-block;
  width: 100%;
}
</style>
